export interface Tee {
    $key?: string;
    color: string;
    name: string;
}

export interface Course {
    $key?: string;
    name: string;
    holes: number;
    tees: {
        [key: string]: Tee;
    };
}

export class Club {
    $key?: string;
    avatar: string;
    avatar_thumb: string;
    background: string;
    registerDate: number;
    city: string;
    country: string;
    address: string;
    courses: {
        [key: string]: Course;
    };
    email: string;
    info: string;
    isVerified: boolean
    location: {
        lat: number;
        lon: number;
    };
    name: string;
    state: string;
    db_phone: string;
    type: number;
    uid: string;
    username: string;
    bank?: {
        stripe_user_id?: string
    }
}
